import * as React from "react";
import { Card } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { getICSEvent } from "@grandvisionhq/lib-ics";
import StoreDetailModal from "../../../../StoreDetailModal/Appointments/components/StoreDetailModal/StoreDetailModal.js";
/* empty css                       */
const AppointmentDetail = ({
  appointmentType,
  cancelLink,
  child,
  customerComment,
  dateAndTime,
  directionsUrl,
  endTime,
  invitee,
  isReservation,
  isCancellable,
  isReschedulable,
  labels,
  mapImageUrl,
  onReschedule,
  onStoreDetailModalClose,
  onStoreDetailModalOpen,
  rescheduleLink,
  startTime,
  store,
  storeDetailModalOpen,
  isVirtualAppointmentType,
  isOldAppointment
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Card.Text, { color: "text-secondary" }, appointmentType?.name), /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h2" }, dateAndTime), /* @__PURE__ */ React.createElement(Card.Section, null, isReservation && labels.reservationTitle ? /* @__PURE__ */ React.createElement(
    Alert,
    {
      variant: "info",
      title: labels.reservationTitle.toString(),
      className: "alert-m-default"
    },
    labels.reservationInfo
  ) : /* @__PURE__ */ React.createElement(Card.ButtonLayout, null, isReschedulable && rescheduleLink && /* @__PURE__ */ React.createElement(Card.Link, { href: rescheduleLink, onClick: onReschedule, iconBefore: "reschedule" }, labels.reschedule), isCancellable && cancelLink && /* @__PURE__ */ React.createElement(Card.Link, { href: cancelLink, iconBefore: "trash" }, labels.cancel))), /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h3" }, labels.when), /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(Card.Content, null, /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head" }, dateAndTime)), store && appointmentType && startTime && endTime && !isReservation && !isOldAppointment ? /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(
    Card.Link,
    {
      iconAfter: "chevron-right",
      onClick: () => getICSEvent({
        description: appointmentType.description,
        timeSlot: { from: startTime, until: endTime },
        name: store.name,
        location: store,
        id: appointmentType.id
      })
    },
    labels.addToCalendar
  )) : null))), !isVirtualAppointmentType && /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h3" }, labels.where), store && /* @__PURE__ */ React.createElement(Card, null, mapImageUrl && /* @__PURE__ */ React.createElement(
    Card.Image,
    {
      className: "appointment-detail__map",
      src: mapImageUrl,
      alt: store.name
    }
  ), /* @__PURE__ */ React.createElement(Card.Content, null, /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head" }, store.name), /* @__PURE__ */ React.createElement(Card.Text, { color: "text-secondary" }, store.streetName, " ", store.town), store.phone && /* @__PURE__ */ React.createElement(Card.Link, { href: `tel:${store.phone}` }, store.phone)), /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Card.ButtonLayout, null, /* @__PURE__ */ React.createElement(Card.Link, { onClick: onStoreDetailModalOpen, iconAfter: "chevron-right" }, labels.viewStoreDetails), directionsUrl && /* @__PURE__ */ React.createElement(Card.Link, { href: directionsUrl, iconAfter: "chevron-right" }, labels.getDirections), store && storeDetailModalOpen && /* @__PURE__ */ React.createElement(
    StoreDetailModal,
    {
      globalStoreId: store.globalStoreId ?? store.code.toString(),
      onModalClose: onStoreDetailModalClose
    }
  )))))), /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h3" }, labels.who), /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(Card.Content, null, /* @__PURE__ */ React.createElement(Card.Section, null, invitee && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head" }, invitee.firstName, " ", invitee.lastName), child && /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head" }, labels.child, ": ", child.firstName, " ", child.lastName), /* @__PURE__ */ React.createElement(Card.Text, null, invitee.email), /* @__PURE__ */ React.createElement(Card.Text, null, invitee.phone))), customerComment && /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head" }, labels.additionalInfo), /* @__PURE__ */ React.createElement(Card.Text, null, customerComment))))));
};
export {
  AppointmentDetail as default
};
//# sourceMappingURL=AppointmentDetail.js.map
